import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_ENDPOINTS, API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints';

import { Appointment } from '@/types/matchDevice';

interface LinkAppointmentToTransmissionRequest {
  appointmentId: string | null;
  transmissionId: number;
}

interface LinkAppointmentToTransmissionResponse {
  success: boolean;
  message: string;
}

export const appointmentApiSlice = createApi({
  reducerPath: 'appointmentApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: Object.values(API_SLICE.Appointment),
  endpoints: (builder) => ({
    getAllAppointment: builder.query<
      Appointment[],
      {
        patientId: string;
        page: number;
        limit: number;
        endDate: string;
        statuses: string[];
        sortOrder: string;
      }
    >({
      query: ({ patientId, page, limit, endDate, statuses }) => ({
        url: API_ENDPOINTS.APPOINTMENT.LIST,
        method: 'GET',
        params: {
          patientId,
          page,
          limit,
          endDate,
          statuses: JSON.stringify(statuses) // Ensure statuses are passed as a valid query parameter
        }
      }),
      transformResponse: (response: { data: Appointment[] }) => response.data
    }),

    linkAppointmentToTransmission: builder.mutation<
      LinkAppointmentToTransmissionResponse,
      LinkAppointmentToTransmissionRequest
    >({
      query: (body) => ({
        url: API_ENDPOINTS.APPOINTMENT.LINK_TRANSMISSION,
        method: 'POST',
        body
      })
    }),

    getActiveAppointments: builder.query<Appointment[], { deviceId: string }>({
      query: ({ deviceId }) => ({
        url: API_ENDPOINTS.APPOINTMENT.ACTIVE(deviceId),
        method: 'GET'
      }),
      transformResponse: (response: { data: Appointment[] }) => response.data
    })
  })
});
export const {
  useGetAllAppointmentQuery,
  useGetActiveAppointmentsQuery,
  useLinkAppointmentToTransmissionMutation
} = appointmentApiSlice;
